import ApiClient from '@/api-client';

export default {
    namespaced: true,
    state: {
        waterLinx: {
            branch: {},
        },
    },
    mutations: {
        setWaterLinx(state, waterLinx) {
            state.waterLinx = waterLinx;
        },
    },
    actions: {
        async getWaterLinx({ commit }, url) {
            const response = await ApiClient.get(url);
            commit('setWaterLinx', response.data);
        },
        async setWaterLinx({ state, dispatch }, waterLinxId) {
            if (state.waterLinx.id !== waterLinxId) {
                dispatch('getWaterLinx', waterLinxId);
            }
        },
    },
};
